import React from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Col,
  Modal,
  Row,
  Tab,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { tambahSupervisor, getAllSupervisor, getAllClient } from "stores";
import { getAllCabang } from "stores";
import { penempatanSupervisor } from "stores";
import { editStatusSupervisor } from "stores";
import { resetPassword } from "stores";
import { Dna } from "react-loader-spinner";
import { settingMenuSS } from "stores";

function ListSupervisor() {
  const dispatch = useDispatch();
  const storeClient = useSelector((state) => state.clientReducer);
  const supervisor = useSelector((state) => state.supervisorReducer);
  const storeCabang = useSelector((state) => state.cabangReducer);
  const auth = useSelector((state) => state.authReducer);
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const [modalSpv, setModalSpv] = React.useState(false);
  const [modalPenempatan, setModalPenempatan] = React.useState(false);
  const [modalEdit, setModalEdit] = React.useState(false);
  const [modalUbahPenempatan, setModalUbahPenempatan] = React.useState(false);
  const [pilihClient, setPilihClient] = React.useState(null);
  const [nama, setNama] = React.useState("");
  const [nik, setNik] = React.useState("");
  const [nopeg, setNopeg] = React.useState("");
  const [listSpv, setListSpv] = React.useState([]);
  const [listClient, setListClient] = React.useState([]);
  const [idClientSpv, setIdClientSpv] = React.useState("");
  const [listCabang, setListCabang] = React.useState([]);
  const [idCabang, setIdCabang] = React.useState(null);
  const [pilihCabang, setPilihCabang] = React.useState(null);
  const [idSupervisor, setIdSupervisor] = React.useState("");
  const [listDetailCabang, setListDetailCabang] = React.useState([]);
  const [modalDetail, setModalDetail] = React.useState(false);
  const [status, setStatus] = React.useState("");
  const [searchText, setSearchText] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(true);
  const [multipleSelect, setMultipleSelect] = React.useState([]);
  const [modalSettingMenu, setModalSettingMenu] = React.useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleNikChange = (e) => {
    const inputNik = e.target.value;
    const formattedNik = inputNik.slice(0, 16);
    setNik(formattedNik);
  };

  const remainingDigits = 16 - nik.length;

  const submitSettingMenu = () => {
    const dataToSend = {
      idSupervisor: idSupervisor,
      menu: multipleSelect.map((option) => option.value),
    };
    settingMenuSS(dataToSend)
      .then((response) => {
        if (response.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          getAllSupervisor(dispatch, { idClient: "" });
          setModalSettingMenu(false);
        } else if (response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      });
  };

  const submitSupervisor = () => {
    if (nik.length < 16) {
      Swal.fire({
        title: "NIK harus 16 digit !!",
        icon: "warning",
      });
      return;
    }
    tambahSupervisor({
      nik: nik,
      nama: nama,
      nopeg: nopeg,
      idClient: idClientSpv,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          getAllSupervisor(dispatch, { idClient: "" });
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.log("ERRORRRR", error);
      });
  };

  const checkStatus = () => {
    if (status.value === undefined || status === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Status wajib diisi !",
      });
    } else {
      submitEditStatus();
    }
  };

  const submitEditStatus = () => {
    editStatusSupervisor({
      idSupervisor: idSupervisor,
      status: status.value,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          getAllSupervisor(dispatch, { idClient: "" });
          setModalEdit(false);
          setStatus("");
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      });
  };

  const submitPenempatan = () => {
    if (pilihCabang === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan Cabang tidak boleh kosong",
      });
    } else {
      penempatanSupervisor({
        idSupervisor: idSupervisor,
        idCabang: idCabang,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          // setIdCabang("");
          // setPilihCabang("");
          getAllSupervisor(dispatch, { idClient: "" });
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const handleModalClose = () => {
    setPilihCabang(null);
    setIdCabang(null);
    setPilihClient(null);
    setModalPenempatan(false);
    setModalSpv(false);
    setIdClientSpv("");
    setPilihClient("");
    setNik("");
    setNopeg("");
    setNama("");
  };

  React.useEffect(() => {
    let tmp =
      supervisor.listSupervisor &&
      supervisor.listSupervisor.map((val) => {
        return {
          ...val,
          action: (
            <div
              className="d-flex align-items-center flex-wrap"
              style={{ gap: "8px" }}
            >
              {auth.role === "super admin" || auth.role === "admin" ? (
                <>
                  {/* TOMBOL PENEMPATAN SUPERVISOR */}
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-map-spv-${val._id}`}>
                        Penempatan Supervisor
                      </Tooltip>
                    }
                  >
                    <Button
                      disabled={val.status !== "aktif"}
                      className="d-flex align-items-center justify-content-center shadow-sm"
                      style={{
                        marginTop: 5,
                        width: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: "none",
                        backgroundColor:
                          val.status === "tidak aktif" ? "#cbd5e1" : "#447DF7",
                        color: "white",
                        cursor:
                          val.status === "tidak aktif"
                            ? "not-allowed"
                            : "pointer",
                        transition: "all 0.2s ease",
                      }}
                      onClick={() => {
                        setIdSupervisor(val._id);
                        getAllCabang(dispatch, { idClient: val.idClient });
                        setModalPenempatan(!modalPenempatan);
                      }}
                      onMouseOver={(e) => {
                        if (val.status === "aktif")
                          e.currentTarget.style.transform = "translateY(-2px)";
                      }}
                      onMouseOut={(e) => {
                        if (val.status === "aktif")
                          e.currentTarget.style.transform = "translateY(0)";
                      }}
                    >
                      <i
                        className="fas fa-map-marked-alt"
                        style={{ fontSize: "16px" }}
                      ></i>
                    </Button>
                  </OverlayTrigger>

                  {/* TOMBOL EDIT STATUS */}
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-edit-spv-${val._id}`}>
                        Edit Status
                      </Tooltip>
                    }
                  >
                    <Button
                      className="d-flex align-items-center justify-content-center shadow-sm"
                      style={{
                        marginTop: 5,
                        width: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: "none",
                        backgroundColor: "#10b981", // Hijau Emerald
                        color: "white",
                        transition: "all 0.2s ease",
                      }}
                      onClick={() => {
                        setIdSupervisor(val._id);
                        setModalEdit(!modalEdit);
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.transform = "translateY(-2px)")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.transform = "translateY(0)")
                      }
                    >
                      <i
                        className="fas fa-edit"
                        style={{ fontSize: "16px" }}
                      ></i>
                    </Button>
                  </OverlayTrigger>

                  {/* TOMBOL RESET PASSWORD */}
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-reset-spv-${val._id}`}>
                        Reset Password
                      </Tooltip>
                    }
                  >
                    <Button
                      className="d-flex align-items-center justify-content-center shadow-sm"
                      style={{
                        marginTop: 5,
                        width: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: "none",
                        backgroundColor: "#f90203", // Merah BPR Jatim
                        color: "white",
                        transition: "all 0.2s ease",
                      }}
                      onClick={async () => {
                        const result = await Swal.fire({
                          title: "Reset Password",
                          text: `Apakah Anda yakin ingin mereset password supervisor ${val.nama}?`,
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#2e3192", // Biru BPR Jatim
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Ya, Reset Password!",
                        });

                        if (result.isConfirmed) {
                          try {
                            const response = await resetPassword({
                              idUser: val._id,
                              role: val.role,
                            });
                            Swal.fire({
                              title: "Sukses",
                              text: response.data.message,
                              icon: "success",
                            });
                          } catch (error) {
                            Swal.fire({
                              title: "Error",
                              text: error.response.data.message,
                              icon: "error",
                            });
                          }
                        }
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.transform = "translateY(-2px)")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.transform = "translateY(0)")
                      }
                    >
                      <i
                        className="fas fa-redo-alt"
                        style={{ fontSize: "16px" }}
                      ></i>
                    </Button>
                  </OverlayTrigger>
                </>
              ) : (
                <span className="text-muted fw-bold ml-2">—</span>
              )}

              {/* TOMBOL SETTING MENU (KHUSUS SUPER ADMIN) */}
              {auth.role === "super admin" && (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-setting-spv-${val._id}`}>
                      Setting Menu
                    </Tooltip>
                  }
                >
                  <Button
                    className="d-flex align-items-center justify-content-center shadow-sm"
                    style={{
                      marginTop: 5,
                      width: "38px",
                      height: "38px",
                      borderRadius: "10px",
                      border: "none",
                      backgroundColor: "#2e3192", // Biru BPR Jatim
                      color: "white",
                      transition: "all 0.2s ease",
                    }}
                    onClick={() => {
                      setModalSettingMenu(!modalSettingMenu);
                      setIdSupervisor(val._id);
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.transform = "translateY(-2px)")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.transform = "translateY(0)")
                    }
                  >
                    <i
                      className="fas fa-user-cog"
                      style={{ fontSize: "16px" }}
                    ></i>
                  </Button>
                </OverlayTrigger>
              )}
            </div>
          ),
        };
      });
    setListSpv(tmp);
  }, [
    supervisor.listSupervisor,
    auth,
    modalEdit,
    modalPenempatan,
    modalSettingMenu,
  ]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeCabang.listCabang &&
      storeCabang.listCabang.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaCabang,
        });
      });

    setListCabang(tmp);
  }, [storeCabang.listCabang]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeClient.listClient &&
      storeClient.listClient.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaClient,
        });
      });

    setListClient(tmp);
  }, [storeClient.listClient]);

  const getStatusUser = (statusUser) => {
    switch (statusUser) {
      case "tidak aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    header: {
      style: { minHeight: "56px" },
    },
    headRow: {
      style: {
        backgroundColor: "#F8F9FC",
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: "#E3E6F0",
      },
    },
    headCells: {
      style: {
        fontWeight: "800",
        fontSize: "13px",
        color: "#4E73DF", // Warna identitas AM
        textTransform: "uppercase",
      },
    },
    rows: {
      style: {
        minHeight: "70px", // Row lebih tinggi agar data tidak sesak
        "&:not(:last-child)": {
          borderBottomStyle: "solid",
          borderBottomWidth: "1px",
          borderBottomColor: "#E3E6F0",
        },
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#5A5C69",
      },
    },
  };
  const colSupervisor = [
    {
      name: "No",
      width: "60px",
      center: true,
      selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
    },
    {
      name: "SUPERVISOR",
      minWidth: "280px",
      center: false,
      cell: (row) => (
        <div className="d-flex align-items-center ml-1 py-2">
          {/* Avatar Inisial (Biru Jatim) */}
          <div
            className="mr-3 d-flex align-items-center justify-content-center rounded-lg shadow-sm"
            style={{
              width: "42px",
              height: "42px",
              background: "linear-gradient(135deg, #2e3192 0%, #1e293b 100%)",
              color: "white",
              fontSize: "16px",
              fontWeight: "900",
            }}
          >
            {row.nama.charAt(0).toUpperCase()}
          </div>
          <div>
            <span
              className="fw-900 text-dark d-block"
              style={{ fontSize: "16px", lineHeight: "1.2" }}
            >
              {row.nama}
            </span>
            <span className="text-muted fw-700" style={{ fontSize: "12px" }}>
              ID: {row.kodeUser} | {row.nopeg}
            </span>
          </div>
        </div>
      ),
    },
    {
      name: "BPD",
      minWidth: "150px",
      omit: auth.role !== "super admin",
      selector: (row) => row.namaClient[0],
    },
    {
      name: "Cabang Penempatan",
      minWidth: "250px",
      cell: (row) => {
        // Jika tidak ada penempatan
        if (
          row.penempatan.length === 0 ||
          (row.penempatan.length === 1 && !row.penempatan[0].namaCabang)
        ) {
          return (
            <div
              className="d-flex align-items-center text-muted"
              style={{ fontStyle: "italic", fontSize: "13px" }}
            >
              <i className="fas fa-minus-circle mr-2 opacity-50"></i> Belum ada
              penempatan
            </div>
          );
        }

        // Jika ada penempatan
        return (
          <div className="py-2">
            {/* Nama Cabang Utama */}
            <div className="d-flex align-items-center mb-1">
              <i
                className="fas fa-map-marker-alt text-danger mr-2"
                style={{ fontSize: "12px" }}
              ></i>
              <span
                style={{
                  fontWeight: "700",
                  color: "#2D3748",
                  fontSize: "14px",
                }}
              >
                {row.penempatan[0].namaCabang}
              </span>
            </div>

            {/* Indikator Cabang Lainnya (Tanpa Blok Warna) */}
            {row.penempatan.length > 1 && (
              <div
                className="d-flex align-items-center mt-1"
                style={{
                  cursor: "pointer",
                  fontSize: "12px",
                  color: "#4E73DF",
                  paddingLeft: "20px", // Agar sejajar di bawah teks nama cabang
                }}
                onClick={() => {
                  setListDetailCabang(row);
                  setModalDetail(true);
                }}
              >
                <span
                  style={{
                    borderBottom: "1px dashed #4E73DF",
                    fontWeight: "600",
                  }}
                >
                  <i
                    className="fas fa-external-link-alt mr-1"
                    style={{ fontSize: "10px" }}
                  ></i>
                  Lihat {row.penempatan.length - 1} cabang lainnya
                </span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      name: "Status",
      minWidth: "140px",
      center: true,
      cell: (row) => {
        const isActive = row.status === "aktif";
        return (
          <span
            style={{
              padding: "6px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "bold",
              backgroundColor: isActive ? "#D1FAE5" : "#FEE2E2",
              color: isActive ? "#065F46" : "#991B1B",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <span
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: isActive ? "#10B981" : "#EF4444",
                marginRight: "8px",
              }}
            ></span>
            {isActive ? "Aktif" : "Tidak Aktif"}
          </span>
        );
      },
    },
    {
      name: "Aksi",
      minWidth: "150px",
      center: true,
      omit: !(auth.role === "super admin" || auth.role === "admin"),
      cell: (row) => row.action, // Pastikan row.action merender button aksi Anda
    },
  ];

  React.useEffect(() => {
    getAllSupervisor(dispatch, { idClient: "" })
      .then(() => {
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
    getAllClient(dispatch);
  }, []);

  return (
    <>
      {/* MODAL SETTING MENU */}
      <Modal
        size="md"
        show={modalSettingMenu}
        onHide={() => setModalSettingMenu(!modalSettingMenu)}
        centered
        contentClassName="border-0 shadow-lg"
      >
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="px-4 pb-4">
          <div className="text-center mb-4">
            <div
              className="d-inline-flex align-items-center justify-content-center mb-3"
              style={{
                width: "60px",
                height: "60px",
                backgroundColor: "#f8fafc",
                borderRadius: "15px",
                color: "#2e3192",
              }}
            >
              <i
                className="fas fa-tasks fa-2x"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%", // Paksa icon ambil ruang penuh
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h4 className="font-weight-bold m-0">SETTING MENU SPV</h4>
            <p className="text-muted small">
              Atur hak akses menu untuk pimpinan unit
            </p>
          </div>
          <Form.Group>
            <label className="small fw-800 text-muted text-uppercase mb-2">
              Pilih Menu Akses
            </label>
            <Select
              isMulti
              classNamePrefix="react-select"
              value={multipleSelect}
              onChange={(v) => setMultipleSelect(v)}
              options={[
                { value: "Dashboard", label: "Dashboard" },
                { value: "Client", label: "Client" },
                { value: "User", label: "User" },
                { value: "Cabang", label: "Cabang" },
                { value: "Target", label: "Target" },
                { value: "Pengajuan", label: "Pengajuan" },
                { value: "Pencairan", label: "Pencairan" },
                { value: "Kunjungan", label: "Kunjungan" },
              ]}
              styles={{ control: (b) => ({ ...b, borderRadius: "12px" }) }}
            />
          </Form.Group>
          <Button
            className="btn-block py-3 mt-4 border-0 shadow-sm fw-900"
            style={{
              background: "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
              borderRadius: "12px",
              color: "white",
            }}
            onClick={submitSettingMenu}
          >
            SIMPAN PERUBAHAN
          </Button>
        </Modal.Body>
      </Modal>

      {/* MODAL EDIT STATUS */}
      <Modal
        size="sm"
        show={modalEdit}
        onHide={() => {
          setStatus("");
          setModalEdit(!modalEdit);
        }}
        centered
        contentClassName="border-0 shadow-lg"
      >
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="px-4 pb-4 text-center">
          <div className="mb-3 text-primary">
            <i
              className="fas fa-user-shield fa-3x"
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%", // Paksa icon ambil ruang penuh
                margin: 0,
                padding: 0,
                lineHeight: 1,
                textAlign: "center",
              }}
            ></i>
          </div>
          <h4 className="font-weight-bold mb-1">EDIT STATUS SPV</h4>
          <p className="text-muted small mb-4">Aktifkan atau bekukan akun</p>
          <Select
            classNamePrefix="react-select"
            value={status}
            onChange={(v) => setStatus(v)}
            options={[
              { value: "true", label: "✅ AKTIF" },
              { value: "false", label: "❌ TIDAK AKTIF" },
            ]}
            styles={{ control: (b) => ({ ...b, borderRadius: "10px" }) }}
          />
          <Button
            className="btn-block py-3 mt-4 border-0 fw-900 shadow-sm"
            style={{
              background: "#2e3192",
              borderRadius: "12px",
              color: "white",
            }}
            onClick={checkStatus}
          >
            UPDATE STATUS
          </Button>
        </Modal.Body>
      </Modal>

      <Modal
        size="md"
        show={modalPenempatan}
        onHide={() => {
          handleModalClose();
          setModalPenempatan(false);
        }}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0 bg-light" />
        <Modal.Body className="bg-light px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <i
                className="fas fa-map-pin fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h3 className="fw-800 text-dark mb-1">Form Penempatan</h3>
            <p className="text-muted">Tentukan cabang tugas untuk Supervisor</p>
          </div>

          <Card className="border-0 shadow-sm" style={{ borderRadius: "20px" }}>
            <Card.Body className="p-4">
              <Form.Group className="mb-4">
                <label className="fw-bold text-dark mb-2">Pilih Cabang</label>
                <Select
                  classNamePrefix="react-select"
                  value={pilihCabang}
                  onChange={(value) => {
                    setPilihCabang(value);
                    setIdCabang(value.value);
                  }}
                  options={listCabang}
                  placeholder="Cari Cabang..."
                />
              </Form.Group>
              <Button
                className="btn-block p-3 text-white"
                style={{
                  border: "none",
                  backgroundColor: "#1D3557",
                  borderRadius: "15px",
                  fontWeight: "800",
                  boxShadow: "0 10px 20px rgba(29, 53, 87, 0.3)",
                }}
                onClick={submitPenempatan}
              >
                SIMPAN PENEMPATAN
              </Button>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Modal
        size="md"
        show={modalDetail}
        onHide={() => setModalDetail(!modalDetail)}
        centered
        contentClassName="border-0 shadow-xl"
      >
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="bg-light px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex", // Pakai flex biasa
                alignItems: "center", // Center vertikal
                justifyContent: "center", // Center horizontal
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginRight: "auto", // Gabungan auto kiri-kanan
                marginLeft: "auto", // biar container birunya di tengah modal
              }}
            >
              <i
                className="fas fa-info-circle fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%", // Paksa icon ambil ruang penuh
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>

            <h3 className="fw-800 text-dark mb-1">Detail Penempatan</h3>
            <p className="text-muted">Informasi jangkauan wilayah Supervisor</p>
          </div>

          <Card className="border-0 shadow-sm" style={{ borderRadius: "20px" }}>
            <Card.Body className="p-4">
              {/* INFO PROFIL */}
              <div className="mb-4 pb-3 border-bottom">
                <Row className="mb-2">
                  <Col xs="5" sm="4" className="text-muted fw-bold small">
                    NAMA LENGKAP
                  </Col>
                  <Col xs="7" sm="8" className="text-dark fw-bold">
                    : {listDetailCabang.nama}
                  </Col>
                </Row>
                <Row className="mb-0">
                  <Col xs="5" sm="4" className="text-muted fw-bold small">
                    JABATAN
                  </Col>
                  <Col xs="7" sm="8" className="text-dark fw-bold">
                    : Supervisor
                  </Col>
                </Row>
              </div>

              {/* LIST CABANG DENGAN TOTAL */}
              <div className="bg-light p-3" style={{ borderRadius: "15px" }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="fw-bold text-primary m-0">
                    <i className="fas fa-map-marked-alt mr-2"></i>Daftar Cabang
                  </h6>
                  {/* BADGE TOTAL CABANG */}
                  <span
                    className="badge bg-white text-primary shadow-sm px-3 py-2"
                    style={{
                      borderRadius: "10px",
                      fontSize: "12px",
                      border: "1px solid #4E73DF",
                    }}
                  >
                    Total:{" "}
                    <span className="fw-800">
                      {listDetailCabang.penempatan?.length || 0}
                    </span>{" "}
                    Cabang
                  </span>
                </div>

                <div
                  style={{
                    maxHeight: "30vh",
                    overflowY: "auto",
                    paddingRight: "5px",
                  }}
                >
                  <ul className="list-group list-group-flush bg-transparent">
                    {listDetailCabang.penempatan &&
                    listDetailCabang.penempatan.length > 0 ? (
                      listDetailCabang.penempatan.map((val, index) => (
                        <li
                          key={index}
                          className="list-group-item bg-transparent border-0 py-2 ps-0 text-dark fw-600 d-flex align-items-center"
                        >
                          <div
                            className="bg-success rounded-circle mr-3 d-flex align-items-center justify-content-center"
                            style={{
                              width: "22px",
                              height: "22px",
                              minWidth: "22px",
                            }}
                          >
                            <i
                              className="fas fa-check text-white"
                              style={{ fontSize: "10px" }}
                            ></i>
                          </div>
                          {val.namaCabang}
                        </li>
                      ))
                    ) : (
                      <li className="list-group-item bg-transparent border-0 text-muted italic">
                        Belum ada cabang terdaftar.
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={modalSpv}
        onHide={() => {
          handleModalClose();
          setModalSpv(false);
        }}
        centered
        contentClassName="border-0 shadow-2xl"
      >
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="px-5 pb-5">
          <div className="d-flex align-items-center mb-4">
            <div
              className="p-3 mr-3 shadow-sm"
              style={{
                background: "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
                borderRadius: "15px",
                color: "white",
              }}
            >
              <i className="fas fa-user-plus fa-lg"></i>
            </div>
            <div>
              <h3 className="m-0 font-weight-bold">TAMBAH SUPERVISOR</h3>
              <p className="m-0 text-muted small">
                Registrasi Akun Baru BPR JATIM
              </p>
            </div>
          </div>

          <Form>
            <Form.Group className="mb-3">
              <label className="small fw-800 text-dark text-uppercase">
                Nomor Induk Kependudukan (NIK)
              </label>
              <div
                className="d-flex align-items-center bg-light border rounded-lg px-3 shadow-sm"
                style={{ height: "55px" }}
              >
                <Form.Control
                  className="border-0 bg-transparent fw-700 h-100"
                  onChange={handleNikChange}
                  value={nik}
                  type="text"
                  placeholder="Ketik 16 digit NIK..."
                />
                <span
                  className={`badge ${remainingDigits === 0 ? "badge-success" : "badge-warning"} py-2 px-3`}
                >
                  {remainingDigits} Digit
                </span>
              </div>
            </Form.Group>

            <Row>
              <Col md="6">
                <Form.Group className="mb-3">
                  <label className="small fw-800 text-dark text-uppercase">
                    Nama Lengkap
                  </label>
                  <Form.Control
                    className="border-0 shadow-sm bg-light fw-600"
                    style={{ height: "50px", borderRadius: "12px" }}
                    placeholder="Nama Sesuai KTP"
                    onChange={(e) => setNama(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-3">
                  <label className="small fw-800 text-dark text-uppercase">
                    No. Karyawan
                  </label>
                  <Form.Control
                    className="border-0 shadow-sm bg-light fw-600"
                    style={{ height: "50px", borderRadius: "12px" }}
                    placeholder="Nomor Pegawai"
                    onChange={(e) => setNopeg(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            {auth.role === "super admin" && (
              <Form.Group className="mb-3">
                <label className="small fw-800 text-dark text-uppercase">
                  Assign ke Client
                </label>
                <Select
                  classNamePrefix="react-select"
                  value={pilihClient}
                  onChange={(v) => {
                    setPilihClient(v);
                    setIdClientSpv(v.value);
                  }}
                  options={listClient}
                  placeholder="Pilih BPD / Unit Kerja"
                  styles={{
                    control: (b) => ({
                      ...b,
                      borderRadius: "12px",
                      minHeight: "50px",
                    }),
                  }}
                />
              </Form.Group>
            )}

            {/* FOOTER ACTION: STACKED FOR RESPONSIVE */}
            <div className="mt-4 pt-2">
              <Button
                className="btn-block py-3 border-0 fw-900 shadow-lg"
                style={{
                  background:
                    "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
                  borderRadius: "15px",
                  color: "white",
                  fontSize: "16px",
                }}
                onClick={submitSupervisor}
              >
                SIMPAN DATA SUPERVISOR
              </Button>
              <Button
                variant="link"
                className="btn-block mt-2 text-muted fw-700 text-decoration-none"
                onClick={() => {
                  handleModalClose();
                  setModalSpv(false);
                }}
              >
                Batalkan
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Tab.Content>
        {/* AREA ACTION & SEARCH (STYLE BPR JATIM) */}
        <div className="px-4 py-2 bg-white">
          <Row className="align-items-center justify-content-between">
            {/* Kolom Tombol Tambah */}
            <Col md="5" xs="12" className="mb-3 mb-md-0">
              {auth.role === "super admin" || auth.role === "admin" ? (
                <Button
                  className="btn-fill btn-wd d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    marginTop: "10px",
                    background:
                      "linear-gradient(135deg, #f90203 0%, #ff4d4d 100%)", // Gradasi Merah Jatim
                    fontWeight: "900",
                    border: 0,
                    borderRadius: "12px",
                    padding: "10px 25px",
                    fontSize: "13px",
                    letterSpacing: "0.5px",
                  }}
                  onClick={() => setModalSpv(!modalSpv)}
                >
                  <i className="fas fa-plus-circle mr-2"></i>
                  TAMBAH SUPERVISOR
                </Button>
              ) : null}
            </Col>

            {/* Kolom Search Bar */}
            <Col md="4" xs="12">
              <InputGroup
                className="shadow-none border rounded-lg"
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  backgroundColor: "#f8fafc",
                }}
              >
                <InputGroup.Prepend>
                  <InputGroup.Text className="bg-transparent border-0">
                    <i className="fas fa-search text-muted"></i>
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  className="border-0 bg-transparent fw-600"
                  style={{
                    paddingLeft: "5px",
                    height: "45px",
                    fontSize: "14px",
                  }}
                  type="text"
                  value={searchText}
                  onChange={handleSearch}
                  placeholder="No Karyawan / Nama Supervisor..."
                />
              </InputGroup>
            </Col>
          </Row>
        </div>

        <hr className="mx-4 my-4" style={{ opacity: "0.05" }} />

        {/* AREA TABLE / LOADING STATE */}
        <Row className="px-4 pb-4">
          <Col md="12">
            {isLoading ? (
              <div
                className="loader-container d-flex flex-column align-items-center justify-content-center"
                style={{
                  minHeight: "40vh",
                  background: "#f8fafc",
                  borderRadius: "20px",
                }}
              >
                <Dna
                  visible={true}
                  height="100"
                  width="100"
                  ariaLabel="dna-loading"
                />
                <h6
                  className="mt-3 font-weight-bold text-muted"
                  style={{ letterSpacing: "2px", fontSize: "12px" }}
                >
                  MEMUAT DATA SUPERVISOR...
                </h6>
              </div>
            ) : (
              <div className="table-responsive rounded-xl shadow-sm border bg-white">
                <DataTable
                  columns={colSupervisor}
                  data={listSpv.filter(
                    (row) =>
                      row.nama
                        .toLowerCase()
                        .includes(searchText.toLowerCase()) ||
                      row.nopeg
                        .toLowerCase()
                        .includes(searchText.toLowerCase()),
                  )}
                  customStyles={{
                    ...customStyles,
                    rows: {
                      style: {
                        minHeight: "75px",
                        "&:hover": {
                          backgroundColor: "#f1f5f9",
                          transition: "0.2s",
                        },
                      },
                    },
                  }}
                  pagination
                  paginationRowsPerPageOptions={[10, 25, 50, 75, 100]}
                  paginationPerPage={itemsPerPage}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  pointerOnHover
                />
              </div>
            )}
          </Col>
        </Row>

        {/* INTERNAL CSS UNTUK AKSI & HOVER */}
        <style>{`
    .fw-600 { font-weight: 600; }
    .rounded-xl { border-radius: 15px !important; overflow: hidden; }
    .btn-fill { transition: all 0.3s ease; }
    .btn-fill:hover { transform: translateY(-2px); box-shadow: 0 5px 15px rgba(249, 2, 3, 0.3) !important; }
    
    .input-group:focus-within {
      border-color: #2e3192 !important;
      box-shadow: 0 0 0 0.2rem rgba(46, 49, 146, 0.1) !important;
    }

    /* Penyesuaian Pagination agar lurus dan rapi */
    .rdt_Pagination {
      font-weight: 700;
      color: #64748b;
    }
  `}</style>
      </Tab.Content>
    </>
  );
}

export default ListSupervisor;
